module.exports = __webpack_public_path__ + "static/media/SWSCRC2-07.b52ebc6c.mp3";